import * as React from 'react';
import { connect } from 'react-redux';
// Styles
const styles = {
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        backgroundColor: '#8fb0ff',
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        color: 'black',
        letterSpacing: 10,
        fontSize: 40,
    },
    description: {
        color: 'rgba(255, 255, 255, 0.35)',
        letterSpacing: 5,
        fontSize: 12,
    },
};
class Root extends React.Component {
    render() {
        return (React.createElement("div", { style: styles.container },
            React.createElement("div", { style: styles.title }, 'LAMALABS.IO'),
            React.createElement("div", { style: styles.description }, 'COMING SOON...')));
    }
}
const mapStateToProps = (state, ownProps) => {
    return {};
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
const RootConnected = connect(mapStateToProps, mapDispatchToProps)(Root);
// export default withRouter(RootConnected);
export default RootConnected;
//# sourceMappingURL=root.js.map


// WEBPACK FOOTER //
// ./src/root.js